import Sys from "./lib.r2/utils/SystemUtils";


//------------------------------------------------------------------------- mseConnect
// e.g. https://table-url:port/rest/status?ex=on
//
export const mseConnect = (state) => {
	const bundle = state.measure_bundle;
	const table = bundle?._tableData;
	const dispatch = state.dispatch;

	if (!bundle || !table) return dispatch({type:'mse-error', payload:{message:'no bundle selected for measurement'}});

	// console.log('table:', table);
	// console.log('bundle:', bundle);

	const uri = 'https://' + table.url + ':' + table.port + '/rest/';
	const url = uri + 'status?ex=on';

	// console.log('---send status:', url, 'gtin=' + bundle.gtin, '...');
	dispatch({type:'message', payload:(state.isSimulation? '[simulation] ' : '')
		+ global.getLabel('multiscan-sending-status') + ' '
		+ table.url + ':' + table.port + ' ...'});

	console.log('send status:', url, '...');

	// ---simulate request
	if (state.isSimulation) return setTimeout(e => {
		if (!table._init){
			return refStart(state);

		}else{
			dispatch('mse-start');
			// return mseStart(state);
		}
	}, 3000);

	
	request(url, (err, body) => {
		if (err || !body){
			return dispatch({type:'mse-error', payload:(state.isSimulation? '[simulation] ' : '')
				+ {code:null, message:err+' '+url}})
		}

		// console.log('body:', body);
		let res = xmlFind(body, 'external_control');

		// console.log('state:', res === 'on' ? 'on' : 'off');
		if (res === 'on'){
			if (!table._init){
				return refStart(state);
			}else{
				dispatch('mse-start');
				// return mseStart(state);
			}
		}else{
			return ('table state: off! ' + body);
		}
	})
}


//------------------------------------------------------------------------- refStart
export const refStart = (state) => {
	const table = state.measure_bundle._tableData;
	const url = 'https://' + table.url + ':' + table.port + '/rest/ref?option=all';

	// console.log('---send ref:', url, '...');
	state.dispatch({type:'message', payload:(state.isSimulation? '[simulation] ' : '')
		+ global.getLabel('multiscan-referencing') + ' ...'});

	console.log('send ref:', url, '...');

	// ---simulate request
	if (state.isSimulation) return setTimeout(e => state.dispatch({type:'ref-complete'}), 3000);

	request(url, (err, body) => {
		if (err || !body){
			table._init = false;
			return state.dispatch({type:'mse-error', payload:{code:null, message:err + ' ' + url}})
		}

		// console.log('body:', body);
		let code = xmlFind(body, 'error');

		if (code || !body){
			let msg = state.config.errorCodes[code] || 'no ref result!'
			state.dispatch({type:'mse-error', payload:{code, message:msg}})

		}else{
			return state.dispatch({type:'ref-complete'});
		}
	})
}


//----------------------------------------------------------------------------- mseStart
// from dispatch mse-start
export const mseStart = (state) => {
	const dispatch = state.dispatch;
	if (!state.measure_bundle) return dispatch({
		type:'mse-error',
		payload:{message:'no bundle selected for measurement'
	}});

	const bundle = state.measure_bundle;
	const table = state.measure_bundle._tableData;
	const mode = bundle._multiscanMode || 'complex'
	const uri = 'https://' + table.url + ':' + table.port + '/rest/';
	const urlm = uri + 'mse?length=mm&weight=g&mode=' + mode + '&barcode=' + bundle.gtin;

	startMeasure(urlm, state.isSimulation, (code, result=null, body=null) => {
		if (code || !result){
			let msg = state.config.errorCodes[code] || 'no scan result!'
			return dispatch({type:'mse-error', payload:{code, message:msg}})
		}

		if (state.useNestedScan){
			bundle.attributes.nestedHeight = Number(result.height)
			bundle.attributes.nesting_bonus = Number(bundle.attributes.height) * 2 - Number(bundle.attributes.nestedHeight)

			let res = 'scan-result:\n-------------------------------\n';
			res += ('height: ' + result.height + '\n');
			res += '-------------------------------';
			console.log('nested-scan complete!');
			console.log(res);

			delete bundle._tableData	//remove tabel data

		}else{
			let res = 'scan-result:\n-------------------------------\n';
			for (let k in result){
				bundle.attributes[k] = result[k];
				res += (k + ': ' + result[k] + '\n');
			}
			res += '-------------------------------';
			console.log('scan complete!');
			console.log(res);
		}

		// bundle.multiscanData = {
		state.scan.multiscanData = {
			multiscan_id	: table.id,
			ts				: Sys.getTimeString(),
			result			: body
		}

		dispatch({type:'measure-complete', payload:state.scan.multiscanData});

		// console.log('---send close:', uri + 'status?ex=off');
		if (!state.isSimulation) request(uri + 'status?ex=off');		//close scan-table
	});
}


//----------------------------------------------------------------------------- startMeasure
const startMeasure = (url, simulation, callback) => {
	console.log('send start:', url, '...');

	// ---simulate request
	if (simulation) return setTimeout(e => callback(null, {
		type: 'test',
		length: 300,
		width: 200,
		height: 100,
		weight: 400,
		barcode: 500
	}), 3000);


	request(url, (err, body) => {
		if (err || !body){
			// console.log('error!', err);
			return callback(err, null);
		}

		// console.log('body:', body);
		let error =  xmlFind(body, 'error');
		if (error){
			return callback(error, null);
		}

		let result = {
			type: xmlFind(body, 'measure_type'),
			length: xmlFind(body, 'length'),
			width: xmlFind(body, 'width'),
			height: xmlFind(body, 'height'),
			weight: xmlFind(body, 'weight'),
			barcode: xmlFind(body, 'barcode')
		}

		// console.log('---result:', result);
		callback(null, result, body);
	})
}


//----------------------------------------------------------------------------- xmlFind
const xmlFind = (str, search) => {
	try {
		let p0 = str.indexOf('>', str.indexOf('<'+search));
		if (p0 === -1) return null;
		let p1 = str.indexOf('</'+search+'>');
		if (p1 === -1) return null;
		return str.substring(p0+1, p1).trim();
		// return str.split('<'+search+'>')[1].split('</'+search+'>')[0].trim();
	} catch (error) {
		return null;
	}
}


//----------------------------------------------------------------------------- request
/*
const request = (url, callback= () => {}) => {
	const request = url.toLowerCase().startsWith('https')? require('https') : require('http');

	let req = request.get(url, res => {
		// res.setEncoding('utf8');
		let body = '';
		res.on('data', data => body += data);
		res.on('end', () => {
			// if (callback) callback(null, JSON.parse(body));
			if (callback) callback(null, body);
		});
	});
	req.on('error', callback)
}
*/


//----------------------------------------------------------------------------- request
const request = (url, callback= () => {}) => {
	fetch(url, callback)
		.then(response => response.text())
		.then(data => {
			// console.log('data:', data);
			if (callback) callback(null, data);

		})
		.catch(err => {
			// console.log('error!', err);
			if (callback) callback(err, null);
		})
}

